var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseSlim = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15.13,
  height: 15.13
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.27 7.57 6.7-6.7c.21-.21.21-.53.02-.72s-.52-.19-.72.02l-6.7 6.7L.87.16A.52.52 0 0 0 .14.14c-.2.2-.19.52.02.72l6.7 6.7-6.7 6.71c-.21.21-.21.53-.02.72s.52.19.72-.02l6.7-6.7 6.7 6.7c.21.21.53.21.72.02.2-.2.19-.52-.02-.72l-6.7-6.7Z",
  fill: "#242424"
})));
export { SvgCloseSlim as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiM2U2YTkyOGQzOGZhZDFlMWVlMjY4NzBmMDBmNzRiZDIuc3ZnIjs=";